import { render } from "./GastroPanelSelectedTests.vue?vue&type=template&id=7c36c14c"
import script from "./GastroPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./GastroPanelSelectedTests.vue?vue&type=script&lang=js"

import "./GastroPanelSelectedTests.vue?vue&type=style&index=0&id=7c36c14c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/testInfo/selectedTestsPreview/GastroPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c36c14c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c36c14c', __exports__)) {
    console.log('reload')
    api.reload('7c36c14c', __exports__)
  }
  
  module.hot.accept("./GastroPanelSelectedTests.vue?vue&type=template&id=7c36c14c", () => {
    console.log('re-render')
    api.rerender('7c36c14c', render)
  })

}


export default __exports__